module.exports = __webpack_public_path__ + "assets/img/warrior-name-86fc16dd.png";